import React from 'react';
import classNames from 'classnames';

import RadioQuestion from './RadioQuestion';
import Checkbox from './Checkbox';
import Emoji from './Emoji';
import { DatePicker, Input } from '../../../Atoms';
import { TextArea, Dropdown } from '../../../Atoms';

const Questions = ({
  type,
  value,
  setAnswer,
  options,
  multiValue,
  setMultipleValue,
  error,
  noValidation,
}) => {
  const handleChange = (e) => {
    setAnswer(e.target.value);
  };

  const handleChangePhone = ({ target: { value: phoneValue } }) => {
    let phone = phoneValue;
    if (phone.length > 12) return;
    if (
      phoneValue.length > value.length &&
      ((phone.length === 4 && phone[3] !== '-') ||
        (phone.length === 8 && phone[7] !== '-'))
    ) {
      const a = value;
      const b = '-';
      const position = phone.length === 4 ? 3 : 7;
      phone = [a.slice(0, position), b, a.slice(position)].join('');
    }
    setAnswer(phone);
  };

  const renderQuestion = () => {
    switch (type) {
      case 'dropdown':
        options = options.map((option) => ({
          title: option.text,
          value: option.id,
        }));
        return (
          <Dropdown options={options} value={value} onChange={handleChange} />
        );
      case 'textarea':
        return (
          <TextArea
            value={value}
            onChange={handleChange}
            formValid={true}
            validators={noValidation ? [] : ['required']}
            errorMessages={noValidation ? [] : ['this field is required']}
            fullWidth
          />
        );
      case 'checkbox':
        return (
          <Checkbox
            multiValue={multiValue}
            setMultipleValue={setMultipleValue}
            options={options}
          />
        );
      case 'radiobutton':
        return (
          <RadioQuestion
            setAnswer={setAnswer}
            value={value}
            options={options}
          />
        );
      case 'emoji':
        return <Emoji setAnswer={setAnswer} options={options} value={value} />;
      case 'date':
        return (
          <DatePicker
            onChange={handleChange}
            value={value ? value : null}
            fullWidth
          />
        );
      case 'number':
        return (
          <Input
            onChange={handleChange}
            value={value}
            type="text"
            validators={noValidation ? [] : ['required']}
            errorMessages={noValidation ? [] : ['this field is required']}
            fullWidth
            formValid={true}
          />
        );
      case 'phone':
        return (
          <Input
            onChange={handleChangePhone}
            value={value}
            type="text"
            fullWidth
            formValid={true}
            validators={
              noValidation
                ? []
                : [
                    'required',
                    'matchRegexp:^(()?\\d{3}())?(-|\\s)?\\d{3}(-|\\s)?\\d{4}$',
                  ]
            }
            errorMessages={
              noValidation
                ? []
                : [
                    'this field is required',
                    'Phone number must be 10 digit number',
                  ]
            }
          />
        );
      default:
        return (
          <Input
            onChange={handleChange}
            value={value}
            type="text"
            fullWidth
            formValid={true}
            validators={noValidation ? [] : ['required']}
            errorMessages={noValidation ? [] : ['this field is required']}
          />
        );
    }
  };

  const classes = classNames('question-wrapper');
  return (
    <div className={classes}>
      {renderQuestion()}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default Questions;
